module.exports = __webpack_public_path__ + "static/media/photo_12.6aef90bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_12.jpg
// module id = 1645
// module chunks = 0